import {jsPDF} from "jspdf";
import "jspdf-autotable";
import {RUBIK_FONT} from "@main/fonts/Rubik";
import {RUBIK_FONT_BOLD} from "@main/fonts/RubukBold";

export class PdfCreator {
    constructor(el, pdfName) {
        this.el = el;
        this.pdfName = pdfName;
        this.pdf = new jsPDF("p","pt","a4");
        this.x = this.pxToPt(20);
        this.pageTopMargin = this.pxToPt(40);
        this.y = this.pageTopMargin;
        this.rightMargin = this.pxToPt(20);
        this.blocks = this.el.querySelectorAll(".js-add-to-pdf");
    }

    generate() {
        this.el.classList.add("toPdf");
        this.addFonts();
        this.blocks.forEach(block => {
            this.addToPdf(block);
        });
        this.pdf.save(this.pdfName + ".pdf");
        this.el.classList.remove("toPdf");
    }

    addFonts() {
        this.pdf.addFileToVFS("Rubik.ttf", RUBIK_FONT);
        this.pdf.addFileToVFS("Rubik-Bold.ttf", RUBIK_FONT_BOLD);
        this.pdf.addFont("Rubik.ttf", "Rubik", "normal");
        this.pdf.addFont("Rubik-Bold.ttf", "Rubik", "bold");
    }

    addToPdf(block) {
        const styles = this.getStyles(block);
        if (block.tagName === "IMG") {
            this.pdf.addImage(block, "PNG", this.x, this.getYPosition(styles), this.pxToPt(styles["width"]), this.pxToPt(styles["height"]));
            this.setNextYPositionImg(block, styles);
        } else if (block.tagName === "CANVAS") {
            this.pdf.addImage(block, "PNG", this.x, this.getYPosition(styles), this.pxToPt(styles["width"]), this.pxToPt(styles["height"]));
            this.setNextYPositionImg(block, styles);
        } else {
            const blockText = this.getHtmlAsText(block);
            if (block.classList.contains("js-add-to-pdf-as-html")) {
                this.setFontWeight(styles);
                this.setFontSize(styles);
                const font = this.pdf.getFont();

                this.pdf.autoTable({
                    theme: "plain",
                    showHeader: "never",
                    startY: this.getYPosition(styles),
                    margin: {
                        top: this.pageTopMargin,
                        left: this.x,
                        right: this.rightMargin
                    },
                    body: [
                        [blockText],
                    ],
                    styles: {
                        font: font.fontName,
                        fontStyle: font.fontStyle
                    }
                });

                this.setNextYPositionHtml(styles);
            } else {
                this.setFontWeight(styles);
                this.setFontSize(styles);
                this.setFontColor(styles);
                this.pdf.text(blockText, this.x, this.getYPosition(styles), {
                    lineHeightFactor: this.getLineHeight(styles)
                });
                this.setNextYPositionText(blockText, styles);
            }
        }
    }

    getStyles(block) {
        const style = window.getComputedStyle(block, null);
        const props = ["font-size", "font-weight", "color", "margin-top", "margin-bottom", "line-height"];
        let blockStyles = {};
        props.forEach(prop => {
            blockStyles[prop] = style.getPropertyValue(prop).replace("px" ,"");
        });
        blockStyles["width"] = block.offsetWidth;
        blockStyles["height"] = block.offsetHeight;
        return blockStyles;
    }

    setFontWeight(styles) {
        if (Number(styles["font-weight"]) >= 500 ) {
            this.pdf.setFont("Rubik", "bold");
        } else {
            this.pdf.setFont("Rubik", "normal");
        }
    }

    setFontSize(styles) {
        this.pdf.setFontSize(this.pxToPt(styles["font-size"]));
    }

    setFontColor(styles) {
        this.pdf.setTextColor(this.rgb2hex(styles["color"]));
    }

    rgb2hex(rgb) {
        return `#${rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/).slice(1).map(n => parseInt(n, 10).toString(16).padStart(2, "0")).join("")}`;
    }

    pxToPt(px) {
        return px * 0.75;
    }

    getLineHeight(styles) {
        return styles["font-size"] / styles["line-height"];
    }

    getYPosition(styles) {
        return this.y + this.pxToPt(styles["margin-top"]);
    }

    getHtmlAsText(block) {
        block.innerHTML = block.innerHTML.replace(/<p[^>]*>/g, "").replace(/<\/p>/g, "\n\n").replace(/<(\/|)br>/g, "\n").trim();
        //return  this.pdf.splitTextToSize(block.textContent || block.innerText, this.pdf.internal.pageSize.getWidth() - this.rightMargin);
        return block.textContent || block.innerText;
    }

    setNextYPositionText(blockText, styles) {
        this.y += Math.round(this.pdf.getTextDimensions(blockText).h);
        this.y += this.pxToPt(styles["margin-bottom"]);
    }

    setNextYPositionImg(block, styles) {
        this.y += this.pxToPt(styles["height"]);
        this.y += this.pxToPt(styles["margin-bottom"]);
    }

    setNextYPositionHtml(styles) {
        this.y += this.pdf.previousAutoTable.finalY;
        this.y += this.pxToPt(styles["margin-bottom"]);
    }
}
